import type { BulkUserRow } from '@/types/bulkUserImport';

const CSV_HEADERS = [
  'FirstName',
  'LastName',
  'Email',
  'UserGroup',
  'Department',
  'CardNumber',
  'DeviceInfo',
] as const;

function escapeCsvCell(value: string): string {
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

function deviceInfoForRow(row: BulkUserRow): string {
  if (row.deviceInfo?.trim()) return row.deviceInfo.trim();
  if (row.hasMobile) return 'Mobile device';
  return '';
}

/** Serialize review-table rows back to CSV text (round-trip with parseBulkUserCsv). */
export function serializeBulkUserCsv(rows: BulkUserRow[]): string {
  const headerLine = CSV_HEADERS.join(',');
  const dataLines = rows.map((row) =>
    [
      row.firstName,
      row.lastName,
      row.email,
      row.userGroup,
      row.department,
      row.cardNumber ?? '',
      deviceInfoForRow(row),
    ]
      .map(escapeCsvCell)
      .join(',')
  );
  return [headerLine, ...dataLines].join('\n');
}
